import React from 'react';
import bioMarkerData from "../../components/data/biomarker-metabolic.json";
// import isWithinTargetRange from './targetRange';
// import getChangeIcon from './getChangeIcon';
import { countBioMarkers } from './countBiomarkers';
import { displayValue, displayTarget, displayChange } from './displayItems';

export const metabolicCounts = countBioMarkers(bioMarkerData);

const BioMarkersMetabolic = () => {
  const { totalMarkers, notMeasured, redFlags, greenCount, targetRange } = countBioMarkers(bioMarkerData);

  
  return (
    <div className="section" id="bio-markers">
      <h2>Bio Markers - Metabolic, Immune & Cellular Health</h2>
      <p>This system focuses on energy production, metabolic efficiency, and cellular resilience. It encompasses the digestive, immune/lymphatic, and renal systems, ensuring nutrient absorption, toxin elimination, and inflammation control. Key factors include mitochondrial function, insulin sensitivity, and cellular repair mechanisms.</p>
      <div className="card-container">
        <h3>Metabolic Markers: {totalMarkers}</h3>
        <h3>Not Measured: {notMeasured}</h3>
        <h3>Red Flags: <span style={{ color: "#ff3300" }}>{redFlags}</span></h3>
        <h3>Within Range: {targetRange}</h3>
        <h3>On Target: <span style={{ color: "#77b300" }}>{greenCount}</span></h3>
      </div>
      <div className="ai-prompt-table">
        <div className="table-header">
          <div className="table-title-bio">Marker</div>
          <div className="table-title-bio">Value</div>
          <div className="table-title-bio">Reference Target</div>
          <div className="table-title-bio">User Target</div>
          <div className="table-title-bio">Tested</div>
          <div className="table-title-bio-short">Change</div>
        </div>
        {bioMarkerData.map((bioMarker, index) => (
          <div className="table-row" key={index}>
            <div className="table-content">{bioMarker.marker}</div>
            <div className="table-content">{displayValue(bioMarker.value, bioMarker)}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'reference')}</div>
            <div className="table-content">{displayTarget(bioMarker.target, bioMarker, 'user')}</div>
            <div className="table-content">{bioMarker.tested.last}</div>
            <div className="table-content-short">{displayChange(bioMarker.change, bioMarker)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BioMarkersMetabolic;